import React, { useEffect, useRef, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { refreshJWT } from '../../services/auth';
import { useUserContext } from '../../context/user';
import { redirectToSignIn } from '../../helpers/authSession';

export const TryRefreshJWT = () => {
    const { setRole, setJwtToken, setJwtRefreshToken, lastPageUrl, setLastPageUrl } = useUserContext();
    const started = useRef(false);
    const [refreshFailed, setRefreshFailed] = useState(false);

    const { mutate } = useMutation({
        mutationFn: refreshJWT,
        retry: false,
        onSuccess: (data) => {
            localStorage.setItem("xAuthToken", data.access);
            localStorage.setItem("xAuthRefreshToken", data.refresh);
            localStorage.setItem("xUserRole", JSON.stringify(data.role));
            setJwtToken(data.access);
            setJwtRefreshToken(data.refresh);
            setRole(data.role);

            if (lastPageUrl) {
                window.location.replace(lastPageUrl);
                setLastPageUrl(null);
            } else {
                window.location.replace('/');
            }
        },
        onError: (error: any) => {
            if ([400, 401, 403, 404].includes(error?.status)) {
                redirectToSignIn();
            } else {
                setRefreshFailed(true);
            }
        }
    });

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        const refresh = localStorage.getItem("xAuthRefreshToken");
        if (refresh) {
            mutate({refresh})
        } else {
            redirectToSignIn();
        }
    }, [mutate])

    const retryRefresh = () => {
        const refresh = localStorage.getItem("xAuthRefreshToken");
        if (!refresh) {
            redirectToSignIn();
            return;
        }
        setRefreshFailed(false);
        mutate({ refresh });
    };

    if (refreshFailed) {
        return (
            <div role="alert">
                <p>Не удалось связаться с сервером для обновления сессии.</p>
                <button type="button" onClick={retryRefresh}>
                    Повторить
                </button>
                <button type="button" onClick={redirectToSignIn}>
                    Войти заново
                </button>
            </div>
        );
    }

    return (
        <div>
            Попытка обновления токена авторизации...
        </div>
    );
};
